import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() totalRows: number = 0;
  @Input() pageSize: number = 5;
  @Input() currentPage: number = 1;
  @Input() pageSizes: number[] = [5, 10, 25, 50];
  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() pageSizeChange = new EventEmitter<number>();

  totalPages = 0;
  startItem = 1;
  endItem = 10

  ngOnInit(): void {
    this.calculateTotalPages();
    this.calculateRange();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalRows'] || changes['pageSize'] || changes['currentPage']) {
      this.calculateTotalPages();
      this.calculateRange();
    }
  }

  calculateTotalPages(): void {
    this.totalPages = this.totalRows > 0 ? Math.ceil(this.totalRows / this.pageSize) : 1;
  }

  calculateRange(): void {
    if (this.totalRows === 0) {
      this.startItem = 0;
      this.endItem = 0;
      return;
    }
  
    this.startItem = (this.currentPage - 1) * this.pageSize + 1;
    this.endItem = Math.min(this.startItem + this.pageSize - 1, this.totalRows);
  }

  onPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--; 
      this.calculateRange();
      this.emitPageChange();
    }
  }

  onNextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.calculateRange();
      this.emitPageChange();
    }
  }

  changePageSize(newSize: any): void {
    this.pageSize = Number(newSize.target.value);
    this.currentPage = 1;
    this.calculateTotalPages();
    this.calculateRange();
    this.pageSizeChange.emit(this.pageSize);
    this.emitPageChange();
  }

  emitPageChange(): void {
    const pageEvent: PageEvent = {
      pageIndex: this.currentPage - 1,
      pageSize: this.pageSize,
      length: this.totalRows,
    };
    this.pageChange.emit(pageEvent);
  }
}